import {
  shippingDestinationSchema,
  type ShippingDestination,
} from "@/domain/cart/shipping-destination";

export const intercityShippingAmountBob = 20;

export function isLocalShippingDestination(destination: ShippingDestination): boolean {
  return destination === "la_paz_el_alto";
}

// The management system derives the stored fee from the destination with the
// same rule in SQL: public.create_external_quote_with_shipping
// (canonical migration 20260926120000) charges Bs 0 for local destinations and
// Bs 20 for every other destination, and the ecommerce quote sends the
// destination as `managementCity`, not as the user-facing label.
export function calculateShippingAmount(destination: ShippingDestination): number {
  const parsedDestination = shippingDestinationSchema.parse(destination);

  return isLocalShippingDestination(parsedDestination) ? 0 : intercityShippingAmountBob;
}
